import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useCanonical } from '../hooks/useCanonical';
import { usePageMeta } from '../hooks/usePageMeta';
import { BlogShell } from './BlogShell';
import { SITE, blogPlayStoreUrl, formatDate, getPost } from './posts';

function BlogPost() {
  const { slug = '' } = useParams();
  const post = getPost(slug);

  useCanonical(`${SITE}/blog/${slug}`);
  usePageMeta(
    post ? post.seoTitle : 'Post not found | Hisab Kitab',
    post?.description ?? 'This post could not be found.',
  );

  if (!post) {
    return (
      <BlogShell>
        <h1 className="text-3xl font-extrabold text-white mb-4">Post not found</h1>
        <Link to="/blog" className="text-yellow-400 hover:underline">
          Back to the blog
        </Link>
      </BlogShell>
    );
  }

  const { Body } = post;
  return (
    <BlogShell>
      <article>
        <nav aria-label="Breadcrumb" className="text-sm text-zinc-500 mb-6">
          <Link to="/" className="hover:text-yellow-400">
            Home
          </Link>
          <span className="mx-2">/</span>
          <Link to="/blog" className="hover:text-yellow-400">
            Blog
          </Link>
        </nav>
        <p className="text-sm text-zinc-500 mb-3">
          {formatDate(post.date)} · {post.readingMinutes} min read
        </p>
        <h1 className="text-3xl sm:text-4xl font-extrabold text-white mb-8 leading-tight">
          {post.title}
        </h1>
        <Body />
        <div className="mt-12 rounded-xl border border-zinc-800 bg-zinc-900/60 p-6 text-center">
          <p className="text-zinc-200 font-semibold mb-4">Plan your spending with Hisab Kitab.</p>
          <a
            href={blogPlayStoreUrl(post.slug)}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block rounded-lg bg-yellow-400 px-5 py-2.5 font-semibold text-zinc-950 hover:bg-yellow-300 transition-colors"
          >
            Get it on Google Play
          </a>
          <p className="text-xs text-zinc-500 mt-3">Available on Android.</p>
        </div>
      </article>
    </BlogShell>
  );
}

export default BlogPost;
